import { Component, getAssetPath, h } from '@stencil/core'

const avatars = [
  getAssetPath('./avatars/Amanda.png'),
  getAssetPath('./avatars/Casey.png'),
  getAssetPath('./avatars/Christopher.png'),
  getAssetPath('./avatars/James.png'),
  getAssetPath('./avatars/Kris.png'),
  getAssetPath('./avatars/Mary.png'),
  getAssetPath('./avatars/Nick.png'),
  getAssetPath('./avatars/Rich.png'),
  getAssetPath('./avatars/Susannah.png'),
  getAssetPath('./avatars/Tai-Lin.png'),
]

@Component({
  tag: 'ui-peeps',
  assetsDirs: ['avatars'],
})
export class Peeps {
  render() {
    return (
      <div class='flex flex-wrap justify-center'>
        {avatars.map((url) => (
          <img
            src={url}
            class='rounded-full'
            style={{
              width: '1em',
              height: '1em',
              marginRight: '-.1em',
              marginBottom: '-.1em',
            }}
          />
        ))}
      </div>
    )
  }
}
